import { connect } from 'react-redux'

import ProfileNewPasswordForm from 'app/session/bc_profile/new_password_container'

export default connect()(ProfileNewPasswordForm)
